import { BaseEntity } from '../models/base';
import { CollectionActions, NamedAction } from './actions';
import { CollectionState, createCollectionState } from './state';
import { PageInfo } from './../providers/api/api';

/** Factory to create a reducer for a named list . */

export function ReducerForCollection(collectionName) {
  return (state, action: NamedAction) => {
    const name = action.collectionName;
    const isInitializationCall = state === undefined;
    if (name !== collectionName && !isInitializationCall) return state;

    return CollectionReducer(state, action);
  };
}

/**
 * Generic reducer for a list of serializable objects with a populated uid field.
 * @param  {CollectionState} state - Initial immutable state
 * @param  {NamedAction} action - Action to perform
 * @returns CollectionState - New state
 */
export function CollectionReducer(
  state = createCollectionState(),
  action: NamedAction
): CollectionState<any> {
  switch (action.type) {
    case CollectionActions.SET: {
      let entities: BaseEntity[] = action.payload;
      let newState = {
        loading: false,
        loaded: true,
        ids: entities.map(entity => entity.uid),
        total_pages: 0,
        total_result: 0,
        entities: entities.reduce((object, entity) => {
          object[entity.uid] = entity;
          return object;
        }, {}),
      };
      return newState;
    }
    case CollectionActions.SET_WITH_PAGE_INFO: {
      let entities: BaseEntity[] = action.payload.items;
      let pageInfo: PageInfo = action.payload.pageInfo;
      let newState = {
        loading: false,
        loaded: true,
        ids: entities.map(entity => entity.uid),
        total_pages: pageInfo ? pageInfo.total_pages : 1,
        total_result: pageInfo ? pageInfo.total_entries : entities.length,
        entities: entities.reduce((object, entity) => {
          object[entity.uid] = entity;
          return object;
        }, {}),
      };
      return newState;
    }

    case CollectionActions.APPEND: {
      let entities: BaseEntity[] = action.payload;
      let newEntities = { ...state.entities };
      let newState = {
        ...state,
        loading: false,
        loaded: true,
        ids: state.ids.concat(entities.map(entity => entity.uid)),
        entities: entities.reduce((object, entity) => {
          object[entity.uid] = entity;
          return object;
        }, newEntities),
      };
      return newState;
    }

    case CollectionActions.ADD: {
      let entity: BaseEntity = action.payload;
      let newState = { ...state };
      newState.ids.push(entity.uid);
      newState.entities[action.payload.uid] = entity;
      return newState;
    }
    case CollectionActions.INSERT: {
      let entity: BaseEntity = action.payload;
      let newState = { ...state };
      newState.ids.unshift(entity.uid);
      newState.entities[action.payload.uid] = entity;
      return newState;
    }
    case CollectionActions.UPDATE: {
      let entity: BaseEntity = action.payload;
      let newState = { ...state };
      if (newState.entities[action.payload.uid]) {
        newState.entities[action.payload.uid] = entity;
      }
      return newState;
    }
    case CollectionActions.SET_LOADING: {
      let loading: boolean = action.payload;
      let newState = { ...state };
      newState.loading = loading;
      return newState;
    }
    case CollectionActions.DELETE: {
      let entity: BaseEntity = action.payload;
      let newState = { ...state };
      newState.ids = newState.ids.filter(id => id !== entity.uid);
      delete newState.entities[entity.uid];
      return newState;
    }
    case CollectionActions.CLEAR_ALL:
      return createCollectionState();
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers.ts